exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-editor-container[data-v-a361ec26]{padding:32px;background-color:#f0f2f5;position:relative}.dashboard-editor-container .github-corner[data-v-a361ec26]{position:absolute;top:0px;border:0;right:0}.dashboard-editor-container .chart-wrapper[data-v-a361ec26]{background:#fff;padding:16px 16px 0;margin-bottom:32px}@media (max-width: 1024px){.chart-wrapper[data-v-a361ec26]{padding:8px}}\n", ""]);

// exports
